import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { QuestionListModel } from 'app/question/models/question-list.model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { QuestionService } from 'app/question/services/question.service';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { HtmlToTextPipe } from 'app/shared/pipes/htmlToText.pipe';

@Component({
    selector: 'app-question-list',
    templateUrl: './question-list.component.html',
    styleUrls: ['./question-list.component.css']
})
export class QuestionListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    questions: QuestionListModel[] = [];
    questionList: QuestionListModel[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;

    constructor(
        private questionService: QuestionService,
        private fb: FormBuilder,
        private sortService: SortService,
        private htmlToTextPipe: HtmlToTextPipe
    ) { }

    ngOnInit() {
        this.headerTitle = { title: 'Questions' };

        this.questionService.getAll().subscribe(
            questions => {
                for (let i = 0; i < questions.length; i++) {
                    questions[i].title = this.htmlToTextPipe.transform(questions[i].title);
                    this.questions.push(questions[i]);
                }
                this.questions = questions;
            },
            error => this.errors = error.errorList
        );
        this.questionList = this.questions;

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.questionList = this.sortService.filterAndSortlist(this.questions, newValue, this.lastSort);
        });
    }

    //onSorted($event: ColumnSortedEvent) {
    //    if ($event.tableId === 'question-list') {
    //        this.lastSort = $event;
    //        this.questionList = this.sortService.filterAndSortlist(this.questions, this.filterTextControl.value, $event);
    //    }
    //}
}
